module.exports = __webpack_public_path__ + "static/media/can-i-pet-that-dawg.972e5aaa.mp3";